import Repository from "./Repository";

export default {
  // Create Project
  createProject(payload) {
    return Repository.post(`/project`, payload);
  },

  // Edit Project
  updateProject(payload) {
    return Repository.put(`/project/${payload.name}`, payload.data);
  },

  // Delete Project
  deleteProject(payload) {
    return Repository.delete(`/project/${payload.name}`, payload);
  },

  // List Projects
  getProjects(payload) {
    return Repository.get(`/project`, {
      params: {
        page: payload ? payload.page : 1,
        size: payload ? payload.size : 10
      }
    });
  },

  // Get User Access List of Project
  getProjectUsers(payload) {
    return Repository.get(`/project/${payload.name}/user`);
  },

  // Delete Project User
  deleteProjectUser(payload) {
    return Repository.delete(`/project/${payload.name}/user`, payload);
  },

  // Invite User to Project
  inviteUser(payload) {
    return Repository.post(`/project/${payload.id}/user`, {
      email: payload.email
    });
  },

  // Accept Invite to Project
  acceptInvite(payload) {
    return Repository.post(`/project/invite/${payload.id}/accept`);
  }
};
